"use strict";
/* eslint-disable  @typescript-eslint/consistent-indexed-object-style,  @typescript-eslint/no-namespace */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=Config.js.map